import React, { Component } from 'react';
import glamorous from 'glamorous';
import { isEmpty } from 'lodash';
import UserCard from '../../common/UserCard';

let center = {textAlign: 'center'};

const UserGrid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(3, 230px)",
  gridGap: "24px 32px",
  justifyContent: "center",
  "@media(max-width: 800px)": {
    gridTemplateColumns: "repeat(1, 1fr)",
    justifyItems: "center"
  }
});

const GridHeader = glamorous.div({
  textAlign: 'center'
});

const Header = glamorous.h2({
  color: '#FFF'
});

class NoResults extends Component {
  renderUserCards = () => {
    const profiles = this.props.profiles;

    if(isEmpty(profiles)) {
      return null;
    }    
    
    if(!isEmpty(profiles)) {
      const cards = Object.keys(profiles).map(key => {
        const profile = profiles[key];
        return (
          <UserCard
            member={profile}
            isFavorite={profile.isFavorite}
            favToggle={this.props.favToggle}
            favKey={key}
            key={key}
          />
        );
      });
      return (
        <div>
          <GridHeader>
            <Header>
              <span style={{backgroundColor: 'black', padding: '5px'}}>
                Check out our Featured Members
              </span>
            </Header>
          </GridHeader>
          <UserGrid> {cards} </UserGrid>
        </div>
      )
    }
  };

  render() {
    return (
      <div style={center}>
        <h2>
          Oops! We couldn't find any {this.props.isMembers ? 'members' : 'trips'}.
        </h2>
        <div>
          <p>
            Try broadening your search filters to see more results.
          </p>
        </div>
        
        {this.renderUserCards()}
      </div>
    );
  }
}

export default NoResults;



// WEBPACK FOOTER //
// ./src/components/pages/Search/NoResults.jsx